import { ChevronRightIcon } from "lucide-react";
import { Text } from "components/text";
import { PickerProject } from "./AddToProjectPicker.types";
import { ProjectRow } from "./ProjectRow";

interface ProjectListSectionProps {
  label: string;
  projects: PickerProject[];
  leadingIcon?: "folder" | "history";
  highlightQuery?: string;
  selectionDisabled?: boolean;
  assignedSelectionEnabled?: boolean;
  onSelect: (project: PickerProject) => void;
  seeAllLabel?: string;
  onSeeAll?: () => void;
}

export const ProjectListSection = ({
  label,
  projects,
  leadingIcon,
  highlightQuery,
  selectionDisabled,
  assignedSelectionEnabled,
  onSelect,
  seeAllLabel,
  onSeeAll,
}: ProjectListSectionProps) => {
  if (projects.length === 0) {
    return null;
  }

  return (
    <section className="flex flex-col">
      <Text as="h3" variant="metricCaption" className="px-2 py-1 uppercase">
        {label}
      </Text>
      {projects.map((project) => (
        <ProjectRow
          key={project.id}
          project={project}
          leadingIcon={leadingIcon}
          highlightQuery={highlightQuery}
          selectionDisabled={selectionDisabled}
          assignedSelectionEnabled={assignedSelectionEnabled}
          onSelect={onSelect}
        />
      ))}
      {seeAllLabel && onSeeAll ? (
        <button
          type="button"
          onClick={onSeeAll}
          disabled={selectionDisabled}
          className="flex w-full items-center gap-1 rounded-sm px-2 py-2 text-sm text-secondary-700 hover:bg-accent disabled:cursor-default disabled:opacity-60"
        >
          <span className="flex-1 text-left">{seeAllLabel}</span>
          <ChevronRightIcon className="h-4 w-4 shrink-0" />
        </button>
      ) : null}
    </section>
  );
};
